const OurMission = () => {
  return (
    <section
      id="mission"
      className="section-padding bg-image overlay-dark dark-bg text-center"
      data-stellar-background-ratio="0.5"
      data-background-img="/img/full/33.jpg"
    >
      <div className="container">
        <h3>Our Mission</h3>
        <p className="lead">
          Our mission is to bridge the gap between data and decisions. At
          Sarentu, we aim to empower enterprises with intelligent ERP ecosystems
          that not only manage processes but actively improve them. Through
          cutting-edge technology and a consultative approach, we help
          businesses gain visibility, control, and foresight—driving sustainable
          growth and innovation.
        </p>
        <a href="#contact-us" className="btn btn-md btn-color">
          GET IN TOUCH
        </a>
      </div>
    </section>
  );
};

export default OurMission;
